import { useQueries, useQuery } from "@tanstack/react-query";
import {
  AutocompleteCustomValuesParams,
  AutocompleteCustomValuesResponse,
  fetchAutocompleteCustomValues
} from "PFCore/services/autocomplete/fetch_autocomplete_custom_values";
import { QueryOptions } from "PFTypes/request_options";

import { customValuesKeys } from "./query_keys";

export const useCustomValuesOptions = (
  params: AutocompleteCustomValuesParams,
  options: QueryOptions<AutocompleteCustomValuesResponse> = {}
) =>
  useQuery<AutocompleteCustomValuesResponse>({
    queryKey: customValuesKeys.options(params),
    queryFn: () => fetchAutocompleteCustomValues(params),
    ...options
  });

export const useManyCustomValuesOptions = (
  paramsList: AutocompleteCustomValuesParams[],
  options: QueryOptions<AutocompleteCustomValuesResponse> = {}
) =>
  useQueries({
    queries: paramsList.map((params) => ({
      queryKey: customValuesKeys.options(params),
      queryFn: () => fetchAutocompleteCustomValues(params),
      ...options
    }))
  });
